import React, { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postInvoicePending, postInvoiceGenerate, postProjectPhaseDetails } from '../../apiservices/ApiServices';

const PaymentDue = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [generateModal, setGenerateModal] = useState(false);
    const [data, setData] = useState([]);
    const [projectData, setProjectData] = useState([]);

    const postInvoices = async (postData) => {
        setLoading(true);
        try {
            const res = await postInvoicePending(postData);
            setData(res?.data?.data?.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        setLoadings(true);
        try {
            const res = await postInvoicePending(postData);
            setData(res?.data?.data?.records);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postInvoices(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Project Name",
                accessor: "project_category",
            },
            {
                Header: "Billing Entity Name",
                accessor: "billing_entity_name",
            },
            {
                Header: "Client Name",
                accessor: "client_name",
            },
            {
                Header: "Invoice Level",
                accessor: "invoice_level",
            },
            {
                Header: "Billing Structure",
                accessor: "billing_structure",
            },
            {
                Header: "Description",
                accessor: "description",
            },
            {
                Header: "Amount Due",
                accessor: "amount",
            },
            {
                Header: "Action",
                accessor: "action",
                billingAmount: true,
            },
        ],
        []
    );

    const actions = ['genrate']
    const subActions = []

    const emptyStatement = {
        projectId: '',
        PhaseId: '',
        products: {
            id: '',
            name: '',
            projectAmount: '',
            invoicedAmount: '',
            remaining: '',
            amounts: '',
        },
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        products: [emptyStatement]
    });

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            let postData = {
                project_id: values.projectId,
                proj_phase_id: values.PhaseId,
                item_breakup: values.products.map((item) => ({
                    id: item?.id,
                    amount: item?.amounts,
                })),
            }
            try {
                const res = await postInvoiceGenerate(postData);
                toast.success(res.data.message);
                setGenerateModal(false);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;


    const handleConfirm = () => {
        setGenerateModal(false);
        formik.resetForm();
    };

    const handleViewInvoices = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        let postData = {
            project_id: rowData?.project_id,
            proj_phase_id: rowData?.proj_phase_id,
        }
        try {
            const res = await postProjectPhaseDetails(postData);
            setProjectData(res.data?.data);
            setFieldValue('projectId', res.data.data?.project_id || '');
            setFieldValue('PhaseId', res.data.data?.proj_phase_id || '');

            const leadProducts = res.data?.data?.item_breakup || [];
            let formattedProducts;
            if (leadProducts.length > 0) {
                formattedProducts = leadProducts.map(item => ({
                    id: item?.id || '',
                    name: item?.name || '',
                    projectAmount: item?.project_amount || '',
                    invoicedAmount: item?.invoiced_amount || '',
                    remaining: item?.remaining || '',
                    amount: '',
                }));
            } else {
                formattedProducts = [{ ...emptyStatement }];
            }
            setFieldValue('products', formattedProducts);


            setGenerateModal(true);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Invoices Payment Due" active="Invoices Payment Due" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table notAddnew">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Invoices Payment Due</h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onGenrateInvoice={handleViewInvoices}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={generateModal}
                handleClose={() => setGenerateModal(false)}
                title='Genrate Invoice'
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
            >
                <div className="invoiceData">
                    <table className="table table-bordered text-nowrap mb-4">
                        <thead>
                            <tr>
                                <th>Project Category</th>
                                <th>Billing Entity</th>
                                <th>Client Name</th>
                                <th>Invoice Level</th>
                                <th>Currency Code</th>
                                <th>Billing Structure</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{projectData?.project_category}</td>
                                <td>{projectData?.billing_entity_name}</td>
                                <td>{projectData?.client_name}</td>
                                <td>{projectData?.invoice_level}</td>
                                <td>{projectData?.currency_code}</td>
                                <td>{projectData?.billing_structure}</td>
                                <td>{projectData?.amount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <table className="table table-bordered text-nowrap mb-0">
                        <tbody>
                            {values?.products?.map((item, ind) => {
                                return (
                                    <tr key={ind}>
                                        <th className="invoiceDataTH">{item.name}</th>
                                        <th className="invoiceDataTH">{item.projectAmount}</th>
                                        <th className="invoiceDataTH">{item.invoicedAmount}</th>
                                        <th className="invoiceDataTH">{item.remaining}</th>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <div className="d-flex align-items-center">
                                                <label style={{ marginRight: 10 }}>Amount</label>
                                                <input
                                                    type="text"
                                                    name={`item[${ind}].amounts`}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={item.amounts}
                                                    onChange={(e) => setFieldValue(`products[${ind}].amounts`, e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div className="modalfooters">
                        <div className="button-boxs grid">
                            <button type="submit" className="btn btn-primary">Genrate Invoice</button>
                            <button onClick={handleConfirm} type="button" className="btn btn-default">Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>
        </>
    )

}
export default PaymentDue